import styled from 'styled-components';

export const Container = styled.div`
  .test-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 64px;
    padding: 10px;
    border: 1px solid ${(props) => props.theme.$gray400};
    border-radius: 4px;
    background: ${(props) => props.theme.$white};
    color: ${(props) => props.theme.$gray900};
    font-weight: 700;
    font-size: 13px;

    .material-icons {
      font-size: 20px;
      margin-bottom: 4px;
      color: ${(props) => props.theme.$primary};
    }

    &:hover:not(:disabled),
    &:focus {
      border-color: ${(props) => props.theme.$primary};
      background: ${(props) => props.theme.$primary_light};
    }

    &:disabled {
      opacity: 0.6;
    }
  }

  .test-feedback {
    min-height: 20px;
    margin: 6px 0 0;
    font-size: 12px;
    text-align: center;
  }
`;
